/**
 * Bits of the event presentation shared by the pages that list events.
 *
 * The state keys come from App\Enums\EventState on the server: the table lives here once, so a
 * running event is the same green on the events page, on a track page and everywhere else.
 */
const STATE_COLORS = {
  scheduled: 'blue-grey',
  running: 'green',
  finished: 'grey',
}

/** Chip colour of an event state; grey for a state this client does not know yet. */
export function eventStateColor(state)
{
  return STATE_COLORS[state] ?? 'grey'
}
